import React, { createContext, useContext, useState } from "react";

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
 const [projectId, setProjectId] = useState(null);
 const [workOrderId, setWorkOrderId] = useState(null);

 return (
 <ProjectContext.Provider
 value={{
 projectId,
 setProjectId,
 workOrderId,
 setWorkOrderId,
 }}
 >
 {children}
 </ProjectContext.Provider>
 );
};

export const useProject = () => useContext(ProjectContext);